module.exports = __webpack_public_path__ + "static/media/12.18e02113.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/female/rhand/12.png
// module id = 929
// module chunks = 0